export default function registerUserPage(Alpine) {
    Alpine.data('userPage', () => ({
        activeTab: 'details',
        betaLocales: [
            'bg', 'de', 'es', 'fr', 'ga', 'gu', 'hi', 'lv', 'nl', 'pl', 'ro',
        ],
        browserModalOpen: false,
        browserString: '',
        copied: false,
        hasSavedTimezone: false,
        selectedLocale: 'en',
        hashToTab() {
            const h = (window.location.hash || '#details').replace('#', '');
            if (h === 'security') {
                return 'security';
            }

            return 'details';
        },
        init() {
            this.activeTab = this.hashToTab();
            this._boundHash = () => {
                this.activeTab = this.hashToTab();
            };
            window.addEventListener('hashchange', this._boundHash);

            const el = document.getElementById('user-server-data');
            if (!el) {
                this.initBrowserString();
                this.$nextTick(() => this.initTimezone());
                return;
            }
            const data = JSON.parse(el.textContent);
            this.selectedLocale = data.initialLocale;
            this.hasSavedTimezone = data.hasSavedTimezone;
            this.initBrowserString();
            this.$nextTick(() => this.initTimezone());
        },
        setTab(tab) {
            this.activeTab = tab;
            const next = tab === 'security' ? '#security' : '#details';
            if (window.location.hash !== next) {
                const url = `${window.location.pathname}${window.location.search}${next}`;
                window.history.replaceState(null, '', url);
            }
        },
        initBrowserString() {
            if (window.Bowser) {
                const b = window.Bowser.getParser(window.navigator.userAgent).getBrowser();
                this.browserString = `${b.name} ${b.version}`;
            }
        },
        initTimezone() {
            if (this.hasSavedTimezone) {
                return;
            }
            const el = this.$refs.timezoneSelect;
            if (!el) {
                return;
            }
            const guess = Intl.DateTimeFormat().resolvedOptions().timeZone;
            const has = Array.from(el.options).some((o) => o.value === guess);
            if (has) {
                el.value = guess;
            }
        },
        localeShowsBeta() {
            return this.betaLocales.includes(this.selectedLocale);
        },
        openBrowserModal() {
            this.browserModalOpen = true;
        },
        closeBrowserModal() {
            this.browserModalOpen = false;
            this.copied = false;
        },
        async copyBrowser() {
            const fallbackCopy = () => {
                const input = this.$refs.browserInput;
                if (!input) {
                    return;
                }
                input.removeAttribute('readonly');
                input.select();
                input.setSelectionRange(0, 99999);
                try {
                    document.execCommand('copy');
                    this.copied = true;
                    setTimeout(() => { this.copied = false; }, 3000);
                } finally {
                    input.setAttribute('readonly', 'readonly');
                }
            };
            if (this.browserString && window.navigator?.clipboard) {
                try {
                    await window.navigator.clipboard.writeText(this.browserString);
                    this.copied = true;
                    setTimeout(() => { this.copied = false; }, 3000);
                } catch {
                    fallbackCopy();
                }
            } else {
                fallbackCopy();
            }
        },
    }));
}
